import React from 'react'
import { BsLinkedin, BsGithub, BsGit } from 'react-icons/bs';

const SocialMedia = () => {
  return (
    <div className='app__social'>
      <div>
        <a href="https://www.linkedin.com/in/inkrafi" target='_blank' rel='noreferrer'>
          <BsLinkedin />
        </a>
      </div>
      <div>
        <a href="https://gitlab.com/inkrafi" target='_blank' rel='noreferrer'>
          <BsGit />
        </a>
      </div>
      <div>
        <a href="https://github.com/inkrafi" target='_blank' rel='noreferrer'>
          <BsGithub />
        </a>
      </div>
    </div>
  )
}

export default SocialMedia